import React, { Component, Fragment } from 'react'
import { Input } from 'semantic-ui-react'
import cn from 'classnames'
import Divider from '@ui/Divider'

const MAX_LENGTH = 20

class OtherInput extends Component {
  handleChange = async (_, { value }) => {
    const { onChange } = this.props
    onChange(value)
  }

  render() {
    const { value, placeholder, hidden } = this.props

    return (
      <Fragment>
        <Divider hidden />
        <div className={cn({ 'visibility-hidden': hidden })}>
          <Input
            maxLength={MAX_LENGTH}
            value={value}
            placeholder={placeholder}
            onChange={this.handleChange}
            fluid
          />
          <div className='flex end'>
            {value ? value.length : 0} / {MAX_LENGTH}
          </div>
        </div>
      </Fragment>
    )
  }
}

export default OtherInput
